// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as PorterStoreIcons from "./PorterStoreIcons.bs.js";
import * as PorterStoreHelpers from "../PorterStoreHelpers.bs.js";
import * as PorterStoreStrings from "../PorterStoreStrings.bs.js";

function PorterStoreItemCard(Props) {
  var item = Props.item;
  var onAction = Props.onAction;
  var action = Props.action;
  var onSizeChange = Props.onSizeChange;
  var match = React.useState(function () {
        return false;
      });
  var setShowSizeDropdown = match[1];
  var showSizeDropdown = match[0];
  var sizeDropdownRef = React.useRef(null);
  React.useEffect((function () {
          if (showSizeDropdown) {
            return PorterStoreHelpers.clickOutsideHandler(sizeDropdownRef, setShowSizeDropdown);
          }
          
        }), [showSizeDropdown]);
  return React.createElement("div", {
              className: "ps-item-card"
            }, React.createElement("div", {
                  className: "ps-item-card__image"
                }, item.imageUrl !== "" ? React.createElement("img", {
                        className: "ps-item-card__img",
                        alt: item.name,
                        src: item.imageUrl
                      }) : React.createElement(PorterStoreIcons.ImagePlaceholder.make, {}), action !== undefined ? (
                    action ? (
                        onAction !== undefined ? React.createElement("button", {
                                className: "ps-item-card__action ps-item-card__action--add",
                                onClick: (function (param) {
                                    return Curry._1(onAction, undefined);
                                  })
                              }, React.createElement(PorterStoreIcons.AddAction.make, {})) : null
                      ) : (
                        onAction !== undefined ? React.createElement("button", {
                                className: "ps-item-card__action ps-item-card__action--remove",
                                onClick: (function (param) {
                                    return Curry._1(onAction, undefined);
                                  })
                              }, React.createElement(PorterStoreIcons.RemoveAction.make, {})) : null
                      )
                  ) : null), React.createElement("div", {
                  className: "ps-item-card__details"
                }, React.createElement("span", {
                      className: "ps-item-card__name"
                    }, item.name), item.price > 0 ? React.createElement("span", {
                        className: "ps-item-card__price"
                      }, PorterStoreStrings.rupeeSymbol + String(item.price)) : null, item.size !== "" && item.variants.length > 1 && onSizeChange !== undefined ? React.createElement("div", {
                        ref: sizeDropdownRef,
                        className: "ps-size-dropdown"
                      }, React.createElement("div", {
                            className: "ps-size-dropdown__trigger",
                            onClick: (function (param) {
                                return Curry._1(setShowSizeDropdown, (function (prev) {
                                              return !prev;
                                            }));
                              })
                          }, React.createElement("span", {
                                className: "ps-size-dropdown__value"
                              }, item.size), React.createElement(PorterStoreIcons.SizeChevron.make, {})), showSizeDropdown ? React.createElement("div", {
                              className: "ps-size-dropdown__menu"
                            }, Belt_Array.map(item.variants, (function (variant) {
                                    var isSelected = variant.sizeCode === item.size;
                                    return React.createElement("div", {
                                                key: variant.sizeCode,
                                                className: isSelected ? "ps-size-dropdown__option ps-size-dropdown__option--selected" : "ps-size-dropdown__option",
                                                onClick: (function (param) {
                                                    if (onSizeChange !== undefined) {
                                                      Curry._1(onSizeChange, variant.sizeCode);
                                                    }
                                                    return Curry._1(setShowSizeDropdown, (function (param) {
                                                                  return false;
                                                                }));
                                                  })
                                              }, React.createElement("span", undefined, variant.sizeCode), isSelected ? React.createElement(PorterStoreIcons.SizeCheck.make, {}) : null);
                                  }))) : null) : (
                    item.size !== "" ? React.createElement("div", {
                            className: "ps-size-dropdown__trigger ps-size-dropdown__trigger--static"
                          }, React.createElement("span", {
                                className: "ps-size-dropdown__value"
                              }, item.size)) : null
                  )));
}

var make = PorterStoreItemCard;

export {
  make ,
  
}
/* react Not a pure module */
